/** Accept numeric Shopify IDs or Collection GIDs without losing integer precision. */
const normalizeShopifyCollectionId = value => {
  if (typeof value === 'number') {
    if (!Number.isSafeInteger(value) || value <= 0) return null;
    value = String(value);
  }
  if (typeof value !== 'string') return null;
  const match = value.trim().match(/^(?:gid:\/\/shopify\/Collection\/)?([1-9]\d{0,19})$/);
  return match ? "gid://shopify/Collection/".concat(match[1]) : null;
};
module.exports = {
  normalizeShopifyCollectionId
};